import { render, staticRenderFns } from "./ProvisaoFuncao.vue?vue&type=template&id=4ed46818&scoped=true"
import script from "./ProvisaoFuncao.vue?vue&type=script&lang=ts"
export * from "./ProvisaoFuncao.vue?vue&type=script&lang=ts"
import style0 from "./ProvisaoFuncao.vue?vue&type=style&index=0&id=4ed46818&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed46818",
  null
  
)

export default component.exports